import { render, staticRenderFns } from "./IWError.vue?vue&type=template&id=3d458f2a&scoped=true"
import script from "./IWError.vue?vue&type=script&lang=js"
export * from "./IWError.vue?vue&type=script&lang=js"
import style0 from "./IWError.vue?vue&type=style&index=0&id=3d458f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d458f2a",
  null
  
)

export default component.exports